import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { TenantEventsController } from '../api/events'

export function useTenantEvents(enabled: boolean): void {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!enabled) return undefined
    const controller = new TenantEventsController({ queryClient })
    controller.start()
    return () => controller.stop()
  }, [enabled, queryClient])
}
